import { apiGetAuth, apiGetAuthWithCustomHeadersResponseType } from '@/utils/api'
import { API_EVENT } from '@/utils/api-url'
import { notificationDanger } from '@/utils/notification'
import { exportCustomHeaderAndResponseType } from '@/utils/helper'

const state = () => {
  return {
    list: { data: [] },
    list_event: { data: [] },
    data_modal_add_edit: {},
    meta_filter: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_LIST (state, payload) {
    state.list = payload
  },
  SET_LIST_EVENT (state, payload) {
    state.list_event = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload){
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListEvent (context, payload) {
    try {
      const response = await apiGetAuth(API_EVENT.LIST_EVENT, payload)
      context.commit('SET_LIST_EVENT', response.data.data)
    } catch (error){
      notificationDanger(error)
    }
  },
  async getListReport (context, payload) {
    try {
      const response = await apiGetAuth(API_EVENT.LIST_REPORT, payload)
      context.commit('SET_LIST', response.data.data)
    } catch (error){
      notificationDanger(error)
    }
  },
  async getExport (_, payload) {
    try {
      const response = await apiGetAuthWithCustomHeadersResponseType(API_EVENT.EXPORT_REPORT, payload)
      exportCustomHeaderAndResponseType(response.data, `Export Event Report & Summary.xlsx`)
    } catch (error) {
      notificationDanger(error)
      throw error
    }
  }
}

const getters = {
  list (state) {
    return state.list
  },
  list_event (state) {
    return state.list_event
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
